import React, {useState, useEffect} from 'react';
import {DialogTitle} from '@material-ui/core';
import {DialogContent, MenuItem} from '@material-ui/core';
import {Formik} from "formik";
import CircularIntegration from '../../widgets/CircularIntergration';
import {TextField, Dialog} from "../../styles/config";
import validator from './validator';
import {useSelector} from "react-redux";
import {createResource, updateResource} from "../../utils/formik";
import Translate, {getAuthorizedCountries, unsetNullValues} from "../../utils/utils";

const AddUser = ({handleCreate, resource, initialValues, handleUpdate, onCloseModal, countries, roles}) => {

    const [loading, setLoading] = useState(false);

    const [open, setOpen] = React.useState(false);

    const currentUser = useSelector(store => store.auth.user);

    useEffect(() => {
        setOpen(initialValues?.id !== undefined);
    }, [initialValues]);

    const closeModal = () => {
        setOpen(false);
        onCloseModal();
    };

    const isCreatingResource = () => {
        return initialValues?.id === undefined;
    };


    const filterRoles = (roles, userId) => {

        if (currentUser.id === userId && currentUser.role.name !== 'SUPER_ADMIN') {
            return roles.filter(role => role.name === currentUser.role.name);
        }

        return roles;
    }

    return (
        <div>
            <button className="btn btn-success btn-elevate kt-add-user__button  kt-login__btn-primary"
                    onClick={() => setOpen(true)}>
                <Translate id="DIALOG.BUTTON.ADD.TITLE"/>
            </button>
            <Dialog style={{backgroundColor: 'rgba(43, 32, 43, 0.8)'}}

                    onClose={closeModal} aria-labelledby="customized-dialog-title" open={open}>
                <DialogTitle id="customized-dialog-title" onClose={closeModal}>
                    <div className="title__user-wrapper">
                        <div className="title__user-action">
                            <CircularIntegration done={!loading} load={loading}/>
                        </div>
                        <div className="title__user-title">
                            <h3>
                                {isCreatingResource() ? <Translate id={"DIALOG.BUTTON.ADD.TITLE"}/> :
                                    <Translate id={"TABLE.ACTIONS.EDIT"}/>} <Translate id={"MENU.USER"}/>
                            </h3>
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent dividers>
                    <Formik
                        initialValues={initialValues}

                        onSubmit={(payload, methods) => isCreatingResource() ? createResource(payload, methods, resource, setLoading, handleCreate) : updateResource(unsetNullValues(payload), methods, resource, setLoading, handleUpdate)}
                        enableReinitialize={!isCreatingResource()}
                    >
                        {({
                              values,
                              status,
                              errors,
                              touched,
                              handleChange,
                              handleBlur,
                              handleSubmit,
                              isSubmitting
                          }) => (
                            <form onSubmit={handleSubmit} className="kt-form">
                                {status && (
                                    <div role="alert" className="alert alert-danger">
                                        <div className="alert-text">{status}</div>
                                    </div>
                                )}
                                <TextField
                                    margin="dense"
                                    variant="outlined"
                                    type="text" autoComplete="off"
                                    label={<Translate id="PROFILE.FORM.FIRST_NAME"/>}
                                    fullWidth={true}
                                    name="first_name"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values?.first_name}
                                    helpertext={touched?.first_name && errors?.first_name}
                                    error={Boolean(touched?.first_name && errors?.first_name)}
                                />
                                <TextField
                                    margin="dense"
                                    variant="outlined"
                                    type="last_name"
                                    label={<Translate id="PROFILE.FORM.LAST_NAME"/>}
                                    fullWidth={true}
                                    name="last_name"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values?.last_name}
                                    helpertext={touched?.last_name && errors?.last_name}
                                    error={Boolean(touched?.last_name && errors?.last_name)}
                                />
                                <TextField
                                    margin="dense"
                                    variant="outlined"
                                    label={<Translate id="DIALOG.FORM.EMAIL"/>}
                                    type="email"
                                    fullWidth={true}
                                    name="email"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values?.email}
                                    helpertext={touched?.email && errors?.email}
                                    error={Boolean(touched?.email && errors?.email)}
                                />
                                <TextField
                                    select
                                    margin="dense"
                                    variant="outlined"
                                    label={<Translate id="TABLE.ROLE"/>}
                                    type="text" autoComplete="off"
                                    fullWidth={true}
                                    name="role_id"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values?.role_id ?? initialValues?.role.id ?? ''}
                                    helpertext={touched?.role_id && errors?.role_id}
                                    error={Boolean(touched?.role_id && errors?.role_id)}
                                >
                                    {filterRoles(roles, initialValues.id).map(role => (
                                        <MenuItem key={role.id} value={role.id}>
                                            {role.name}
                                        </MenuItem>
                                    ))}
                                </TextField>
                                <TextField
                                    select
                                    margin="dense"
                                    variant="outlined"
                                    label={<Translate id="TABLE.COUNTRY"/>}
                                    fullWidth={true}
                                    name="country_id"
                                    onBlur={handleBlur}
                                    onChange={handleChange}
                                    value={values?.country_id ?? initialValues?.country_id ?? ''}
                                    helpertext={touched?.country_id && errors?.country_id}
                                    error={Boolean(touched?.country_id && errors?.country_id)}
                                >
                                    {getAuthorizedCountries(countries, currentUser).map(country => (
                                        <MenuItem key={country.id} value={country.id}>
                                            {country.name}
                                        </MenuItem>
                                    ))}

                                </TextField>
                                <div className="kt-add-user__actions">
                                    <button
                                        type="submit"
                                        disabled={isSubmitting || Object.is(initialValues, values)}
                                        className={`btn btn-success btn-elevate kt-add-user__save  kt-login__btn-primary`}

                                    >
                                        {isCreatingResource() ? <Translate id={"DIALOG.FORM.BUTTON.SAVE"}/> :
                                            <Translate id={"DIALOG.FORM.BUTTON.UPDATE"}/>}
                                    </button>
                                    <i
                                        onClick={closeModal}
                                        className={`btn btn-success btn-elevate kt-add-user__button  kt-login__btn-primary`}
                                    >
                                        <Translate id={"DIALOG.FORM.BUTTON.CLOSE"}/>
                                    </i>
                                </div>
                            </form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default AddUser;
